import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaAnestesistas.vue?vue&type=template&id=68a7a475&scoped=true"
import script from "./ModalSolicitacaoCirurgiaAnestesistas.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaAnestesistas.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaAnestesistas.vue?vue&type=style&index=0&id=68a7a475&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a7a475",
  null
  
)

export default component.exports